import React, { useEffect, useState } from "react";
import Aos from "aos";
import Landing from "./content/Landing";
import AboutClinic from "./content/AboutClinic";
import AboutDR from "./content/AboutDR";
import Certificates from "./content/Certificates";
import Directions from "./content/Directions";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllData } from "../../../redux/slices/mainDataSlice";

const Home = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  return (
    <>
      <section className="home">
        <Landing />
        <AboutClinic />
        <AboutDR />
        <Certificates />
        <Directions />
      </section>
    </>
  );
};

export default Home;
